'use client'

import { useRegisterForm } from '@/lib/commerce/hooks'
import { TextField } from '../elements/Field'
import { authLink, authPrimaryButton, authTitle } from './authStyles'

export default function Register({ vendor }: { vendor?: any }) {
  const f = useRegisterForm(vendor)

  return (
    <div>
      <h1 className={authTitle}>Бүртгэл үүсгэх</h1>
      <p className="mt-3 text-sm text-muted-foreground">Мэдээллээ оруулж бүртгэл үүсгэнэ үү</p>

      <form onSubmit={f.handleRegister} className="mt-10 flex flex-col gap-5">
        <div className="grid grid-cols-2 gap-4">
          <TextField label="Овог" placeholder="Таны овог" onChange={e => f.setLastName(e.target.value)} autoComplete="family-name" autoFocus />
          <TextField label="Нэр" placeholder="Таны нэр" onChange={e => f.setFirstName(e.target.value)} autoComplete="given-name" />
        </div>
        <TextField label="Имэйл хаяг" type="email" placeholder="example@shop.mn" onChange={e => f.setEmail(e.target.value)} autoComplete="email" />
        <TextField label="Утасны дугаар" type="text" inputMode="tel" placeholder="00000000" onChange={e => f.setPhone(e.target.value)} autoComplete="tel" />
        <TextField label="Нууц үг" type="password" placeholder="Таны шинэ нууц үг" onChange={e => f.setPassword(e.target.value)} onKeyDown={f.handleKeyDown} description="8-аас дээш тэмдэгтэй байх ёстой" autoComplete="new-password" />
        <button type="submit" disabled={f.loading} className={`mt-2 ${authPrimaryButton}`}>{f.loading ? 'Бүртгүүлж байна…' : 'Бүртгүүлэх'}</button>
      </form>

      <p className="mt-8 pt-8 border-t border-border text-sm text-muted-foreground">
        Аль хэдийн бүртгэлтэй юу?{' '}
        <button type="button" onClick={f.routeToLogin} className={authLink}>Нэвтрэх</button>
      </p>
    </div>
  )
}
